/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderutilizedGcpAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderutilizedGcpAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderutilizedGcpAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderutilizedGcpAdvisorResource>): RecommendationForFinopsUnderutilizedGcpAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsUnderutilizedGcpAdvisorResource(), model);
        RecommendationForFinopsUnderutilizedGcpAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderutilizedGcpAdvisorResource>): RecommendationForFinopsUnderutilizedGcpAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsUnderutilizedGcpAdvisorResource.newInstance(<RecommendationForFinopsUnderutilizedGcpAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderutilizedGcpAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderutilizedGcpAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderutilizedGcpAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderutilizedGcpAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
